import { render, staticRenderFns } from "./ComuPref.vue?vue&type=template&id=670cec0e&scoped=true&"
import script from "./ComuPref.vue?vue&type=script&lang=js&"
export * from "./ComuPref.vue?vue&type=script&lang=js&"
import style0 from "./ComuPref.vue?vue&type=style&index=0&id=670cec0e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670cec0e",
  null
  
)

export default component.exports